var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { NotificationSetting, UserType } from '../../models/user';
import { apiEndpoints, defaultPlatformSettings, CommonConstant } from '../app.constants';
import { Observable } from 'rxjs/Observable';
import { BackendHttpService } from '../core/backend-http.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ObjectUtils } from '../utils/object.utils';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs/Subject';
import { CacheService } from './cache/cache.service';
import { EventFilterType, EventType } from '../../models/user-notification';
import { retry, tap, map, catchError, filter as rxFilter, distinctUntilChanged, switchMap, shareReplay } from 'rxjs/operators';
import { CompanyStatus } from '../../models/common';
import { WebUtils } from '../utils/web.utils';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { of } from 'rxjs/observable/of';
var UserService = /** @class */ (function (_super) {
    __extends(UserService, _super);
    function UserService(router, translate, cacheService) {
        var _this = _super.call(this, router, translate) || this;
        _this.router = router;
        _this.translate = translate;
        _this.cacheService = cacheService;
        _this.companyId = new BehaviorSubject(undefined);
        _this._platformSettings = new BehaviorSubject(defaultPlatformSettings);
        _this._accountLevels = new BehaviorSubject(undefined);
        _this.allAdvertisers = [];
        _this._hasStartedTrial = false;
        _this._canViewCampaignNotification = true;
        _this._contactSupportSubject = new Subject();
        _this.userAvatar = CommonConstant.DEFAULT_USER_AVATAR;
        _this._activatedInfluencerUpdate = new BehaviorSubject(null);
        _this._executeInvalidActionLevel = new BehaviorSubject(undefined);
        _this.setupActivatedInfluencerUpdateFlow();
        return _this;
    }
    UserService.prototype.updatePlatformSettings = function (platformSettings) {
        this._platformSettings.next(platformSettings);
    };
    UserService.prototype.updateAccountLevel = function (accountLevel) {
        this._accountLevels.next(accountLevel);
    };
    UserService.prototype.isFreeUser = function () {
        var accountLevels = this._accountLevels.getValue();
        return accountLevels && accountLevels.level && accountLevels.level.name === 'Free';
    };
    UserService.prototype.isPremiumAccount = function () {
        var accountLevels = this._accountLevels.getValue();
        return accountLevels && accountLevels.level && accountLevels.level.name === 'Premium';
    };
    UserService.prototype.isEnterpriseAccount = function () {
        var accountLevels = this._accountLevels.getValue();
        return accountLevels && accountLevels.level && accountLevels.level.name === 'Enterprise';
    };
    UserService.prototype.accountType = function () {
        var accountLevels = this._accountLevels.getValue();
        return accountLevels && accountLevels.level ? accountLevels.level.name : null;
    };
    Object.defineProperty(UserService.prototype, "maxResultPerSearch", {
        get: function () {
            var accountLevels = this._accountLevels.getValue();
            if (!accountLevels) {
                return null;
            }
            if (accountLevels.monthlyResultPerSearch) {
                return accountLevels.monthlyResultPerSearch;
            }
            else {
                return accountLevels.level ? accountLevels.level.maxResultPerSearch : null;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserService.prototype, "maxGroupInfluencers", {
        get: function () {
            var accountLevels = this._accountLevels.getValue();
            if (!accountLevels) {
                return null;
            }
            // Todo: consider to remove in error handling
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserService.prototype, "maxCampaignInfluencers", {
        get: function () {
            var accountLevels = this._accountLevels.getValue();
            if (!accountLevels) {
                return null;
            }
            // Todo: consider to remove in error handling
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserService.prototype, "maxActiveInfluencers", {
        get: function () {
            var accountLevels = this._accountLevels.getValue();
            if (!accountLevels) {
                return null;
            }
            if (accountLevels.monthlyActiveInfluencers) {
                return accountLevels.monthlyActiveInfluencers;
            }
            return accountLevels.level.maxActiveInfluencers;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserService.prototype, "maxListeningMentions", {
        get: function () {
            var accountLevels = this._accountLevels.getValue();
            if (!accountLevels) {
                return null;
            }
            // Todo: consider to remove in error handling
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserService.prototype, "currentUserLevel", {
        get: function () {
            var accountLevels = this._accountLevels.getValue();
            if (!accountLevels) {
                return null;
            }
            return accountLevels.level;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserService.prototype, "accountLevelName", {
        get: function () {
            var currentLevel = this.currentUserLevel;
            return currentLevel ? currentLevel.name : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserService.prototype, "accountLimitations", {
        get: function () {
            var accountLevels = this._accountLevels.getValue();
            if (!accountLevels) {
                return null;
            }
            return accountLevels.limitations;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserService.prototype, "chartColors", {
        get: function () {
            var platformSettings = this._platformSettings.getValue();
            return platformSettings.chartColors;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserService.prototype, "logoImage", {
        get: function () {
            if (this.isInfluencer) {
                return defaultPlatformSettings.influencerAppLogoContent;
            }
            var platformSettings = this._platformSettings.getValue();
            return platformSettings && platformSettings.logoContent != null ? platformSettings.logoContent : defaultPlatformSettings.logoContent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserService.prototype, "leftSidebarLogoImage", {
        get: function () {
            var platformSettings = this._platformSettings.getValue();
            if (platformSettings === defaultPlatformSettings) {
                return defaultPlatformSettings.leftSidebarLogoContent;
            }
            return platformSettings && platformSettings.logoContent != null ? platformSettings.logoContent : defaultPlatformSettings.leftSidebarLogoContent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserService.prototype, "platformName", {
        get: function () {
            var platformSettings = this._platformSettings.getValue();
            return platformSettings.platformName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserService.prototype, "platformBackground", {
        get: function () {
            var platformSettings = this._platformSettings.getValue();
            return platformSettings ? platformSettings.platformBgColor : defaultPlatformSettings.platformBgColor;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserService.prototype, "platformSettings", {
        get: function () {
            return this._platformSettings.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserService.prototype, "accountLevels", {
        get: function () {
            return this._accountLevels.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    UserService.prototype.hasCreditBaseBilling = function () {
        if (!localStorage.getItem('user')) {
            return false;
        }
        var user = ObjectUtils.parseJSON(localStorage.getItem('user'));
        return user.hasBilling;
    };
    Object.defineProperty(UserService.prototype, "isSsoUser", {
        get: function () {
            if (this._isSsoUser !== undefined) {
                return this._isSsoUser;
            }
            return localStorage.getItem('isSsoUser') === 'true';
        },
        enumerable: true,
        configurable: true
    });
    UserService.prototype.setIsSsoUser = function (isSsoUser) {
        this._isSsoUser = isSsoUser;
        localStorage.setItem('isSsoUser', JSON.stringify(isSsoUser));
    };
    UserService.prototype.clearIsSsoUser = function () {
        this._isSsoUser = undefined;
        localStorage.removeItem('isSsoUser');
    };
    /**
     * change company id when switching account
     * @param {number} id
     */
    UserService.prototype.setCompanyId = function (id, byActiveAccountUpdateInUrl, leaveInactiveState) {
        var _this = this;
        var activeAccount = this.allAdvertisers.find(function (adver) { return adver.id === id; });
        // if the active account is not belonged to current agency. Redirect to login page
        if (!activeAccount) {
            this.setFirstAccountAsActive(this.allAdvertisers, null, byActiveAccountUpdateInUrl);
            return;
        }
        this._hasStartedTrial = activeAccount.isTrialed;
        if (this.getCompanyId() === id) {
            return;
        }
        if (activeAccount.inactive) {
            // if user change activeAccount only by updating url, navigate to inactive user page if needed
            // if user change path, inactive account case is handle by auth guard
            if (byActiveAccountUpdateInUrl) {
                WebUtils.navigateToInactivePageIfNeeded(id);
            }
            // just set the company and not call the below apis because of authorization
            this.companyId.next(id);
            return;
        }
        // get out of inactive state if needed
        // ex: admin change account from inactive one to active one
        var getOutOfInactiveState = leaveInactiveState && !activeAccount.inactive;
        // load platform settings for non-SSO users
        if (!this.isSsoUser) {
            this.loadPlatformSettingByCampanyId(id);
        }
        // Influencer companies have no account level configured
        if (!this.isInfluencer) {
            // load account levels of new account
            this.loadAccountLevelsOfCampanyId(id);
        }
        this.getLastViewedTime(EventType.NEW_CAMPAIGN_POST, id).subscribe(function (res) {
            _this._lastViewedCampaignTime = res;
            _this._canViewCampaignNotification = true;
            // update new account id
            _this.companyId.next(id);
            if (getOutOfInactiveState) {
                WebUtils.getOutOfInactiveStateIfNeeded();
            }
        }, function (err) {
            _this._lastViewedCampaignTime = null;
            if (err.status === 403) {
                _this._canViewCampaignNotification = false;
            }
            // update new account id
            _this.companyId.next(id);
            if (getOutOfInactiveState) {
                WebUtils.getOutOfInactiveStateIfNeeded();
            }
        });
    };
    /**
     * set company based on current influencer
     * @param {number} id
     */
    UserService.prototype.setCurrentCompanyForInfluencer = function (id) {
        this.companyId.next(id);
    };
    UserService.prototype.manuallyUpdateActiveAccount = function (accountId) {
        var isAccountExisted = this.allAdvertisers.findIndex(function (adver) { return adver.id === accountId; }) >= 0;
        if (!isAccountExisted) {
            return;
        }
        this.companyId.next(accountId);
    };
    /**
     * Fetch and update platform setting of company base on id
     * @param companyId
     */
    UserService.prototype.loadPlatformSettingByCampanyId = function (companyId) {
        var _this = this;
        this.getPlatformSettings(companyId).subscribe(function (setting) {
            _this.updatePlatformSettings(setting);
        }, function (error) {
            _this.updatePlatformSettings(defaultPlatformSettings);
        });
    };
    /**
     * Fetch and update platform setting of company base on id
     * @param companyId
     */
    UserService.prototype.loadAccountLevelsOfCampanyId = function (companyId) {
        var _this = this;
        this.getAccountLevels(companyId).subscribe(function (levels) {
            _this.updateAccountLevel(levels);
        });
    };
    UserService.prototype.getCompanyId = function () {
        return this.companyId.getValue();
    };
    UserService.prototype.resetActiveAccount = function () {
        this.companyId.next(undefined);
    };
    UserService.prototype.setActiveCompany = function (listAdvertiser, belongingCompany, defaultActiveAccount) {
        if (Array.isArray(listAdvertiser) && listAdvertiser.length > 0) {
            // for admin and agency account
            this.allAdvertisers = listAdvertiser;
        }
        else {
            // advertiser accounts don’t necessarily have a governing agency. So, use the company which it's belonging to
            this.allAdvertisers = [belongingCompany];
        }
        if (this.getCompanyId()) {
            return;
        }
        this.setFirstAccountAsActive(this.allAdvertisers, defaultActiveAccount);
    };
    UserService.prototype.setFirstAccountAsActive = function (listAdvertises, defaultActiveAccount, byActiveAccountUpdateInUrl) {
        if (defaultActiveAccount) {
            this.setCompanyId(defaultActiveAccount, byActiveAccountUpdateInUrl);
        }
        else if (listAdvertises && listAdvertises[0] && listAdvertises[0].id) {
            if (this.isAgency || this.isAdmin) {
                this.setActiveAccountForAgencyOrAdmin(listAdvertises, byActiveAccountUpdateInUrl);
                return;
            }
            this.setCompanyId(listAdvertises[0].id, byActiveAccountUpdateInUrl);
        }
    };
    UserService.prototype.setActiveAccountForAgencyOrAdmin = function (listAdvertises, byActiveAccountUpdateInUrl) {
        // try to find 1st active company
        var firstActiveCompany = listAdvertises.find(function (ad) { return !ad.inactive; });
        if (firstActiveCompany) {
            this.setCompanyId(firstActiveCompany.id, byActiveAccountUpdateInUrl);
            return;
        }
        // otherwise use the 1st inactive company
        this.setCompanyId(listAdvertises[0].id, byActiveAccountUpdateInUrl);
    };
    UserService.prototype.getAllProjectOfAdvertiser = function () {
        var currentUser = ObjectUtils.parseJSON(localStorage.getItem('user'));
        if (currentUser === null) {
            return Observable.of([]);
        }
        return this.get(apiEndpoints.getProjectOfAdvertiser + this.getCompanyId());
    };
    UserService.prototype.getAllAdvertiser = function (type, companyId) {
        var endpoint = apiEndpoints.getGoverningAgencyByAgency + companyId;
        if (type === UserType.ADMIN) {
            endpoint = apiEndpoints.getAllAdvertiser;
        }
        return this.get(endpoint).pipe(map(function (res) {
            var data = res && res.data;
            if (data) {
                data.forEach(function (x) { return x.startDate = new Date(x.startDate * 1000); });
            }
            return res;
        }));
    };
    UserService.prototype.getCurrentUserInfo = function () {
        return this.get(apiEndpoints.me).pipe(map(function (res) {
            var userData = res && res.data;
            if (userData) {
                var company = userData.company;
                company.startDate = new Date(company.startDate * 1000);
            }
            return res;
        }));
    };
    UserService.prototype.getCurrentAdvertiser = function () {
        var _this = this;
        if (Array.isArray(this.allAdvertisers) && this.allAdvertisers.length > 0) {
            return this.allAdvertisers.find(function (adv) { return adv.id === _this.getCompanyId(); });
        }
        return null;
    };
    /**
     * this method use to create new invited user
     * @param {string} hashString
     * @param {UserProfile} user
     * @returns {Observable<any>}
     */
    UserService.prototype.acceptionInvitation = function (hashString, user, companyName) {
        var splitName = user.fullName.split(' ');
        if (splitName.length >= 2) {
            user.firstName = splitName[0];
            user.lastName = splitName[2] || splitName[1];
        }
        else {
            user.firstName = splitName[0];
            user.lastName = '';
        }
        user.companyName = companyName;
        user.packageSub = 'PRO';
        return this.post(apiEndpoints.acceptInvitation, {
            hashString: hashString, profile: user
        });
    };
    /**
     * this method use to check the invitation hashlink before creating new user
     * @param {string} hashString
     * @param {UserProfile} user
     * @returns {Observable<any>}
     */
    UserService.prototype.precheckHashLink = function (hashString) {
        return this.post(apiEndpoints.precheckHashLink, { hashString: hashString }).map(function (res) { return res.data; });
    };
    /**
     * this method use to register an request demo
     * @param {data}
     * @returns {Observable<any>}
     */
    UserService.prototype.register = function (data) {
        return this.post(apiEndpoints.register, data).map(function (res) { return res.data; });
    };
    UserService.prototype.authorizeUserByToken = function (token) {
        return this.get(apiEndpoints.authorizeUserByToken + '/' + token);
    };
    UserService.prototype.authorizeUserByInviteToken = function (token, campaignId) {
        return this.get(apiEndpoints.authorizeUserByInviteToken, {
            inviteToken: token,
            campaignId: campaignId
        });
    };
    UserService.prototype.savePlatformSettings = function (companyId, platformSettings) {
        return this.put(apiEndpoints.platformSettings.replace(':companyId', companyId.toString()), platformSettings);
    };
    UserService.prototype.getPlatformSettings = function (companyId) {
        return this.get(apiEndpoints.platformSettings.replace(':companyId', companyId.toString())).map(function (res) { return res.data; });
    };
    UserService.prototype.getAccountLevels = function (companyId) {
        return this.get(apiEndpoints.accountLevels.replace(':companyId', companyId.toString()))
            .pipe(map(function (res) { return res.data; }), catchError(function (error) {
            WebUtils.reportErrorToSentry('Get Account Levels error', error);
            return Observable.throw(error);
        }));
    };
    UserService.prototype.getCompanyName = function (companyId) {
        var company = this.allAdvertisers.find(function (adv) { return adv.id === companyId; });
        if (!company) {
            return null;
        }
        return company.name;
    };
    UserService.prototype.getAdvertiserList = function () {
        return this.allAdvertisers.map(function (adv) { return ({
            id: adv.id,
            name: adv.name,
            status: adv.status,
            inactive: adv.inactive
        }); });
    };
    UserService.prototype.doInvalidActionByLevel = function (actionName, errorMsg) {
        this._executeInvalidActionLevel.next({
            actionName: actionName,
            message: errorMsg ? errorMsg : this.translate.instant('common.invalid_action_by_levels_warning.common_msg')
        });
    };
    Object.defineProperty(UserService.prototype, "invalidActionLevelObject", {
        get: function () {
            return this._executeInvalidActionLevel.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    UserService.prototype.resetInvalidActionObject = function () {
        this._executeInvalidActionLevel.next(undefined);
    };
    UserService.prototype.signUp = function (newUser) {
        if (this.isExistedUTMData()) {
            newUser = Object.assign({}, newUser, {
                utm_source: localStorage.getItem('utm_source'),
                utm_campaign: localStorage.getItem('utm_campaign'),
                utm_medium: localStorage.getItem('utm_medium')
            });
        }
        return this.post(apiEndpoints.signUp, newUser);
    };
    UserService.prototype.isExistedUTMData = function () {
        return localStorage.getItem('utm_source') || localStorage.getItem('utm_campaign') || localStorage.getItem('utm_medium');
    };
    UserService.prototype.resetPassword = function (data) {
        return this.post(apiEndpoints.resetPasswordHash, data).map(function (res) { return res.data; });
    };
    UserService.prototype.verifyEmail = function (token) {
        return this.get(apiEndpoints.emailVerification, { token: token });
    };
    Object.defineProperty(UserService.prototype, "isAdmin", {
        get: function () {
            var user = ObjectUtils.parseJSON(localStorage.getItem('user'));
            return user && user.type === UserType.ADMIN;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserService.prototype, "isAgency", {
        get: function () {
            var user = ObjectUtils.parseJSON(localStorage.getItem('user'));
            return user && user.type === UserType.AGENCY;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserService.prototype, "isAdvertiser", {
        get: function () {
            var user = ObjectUtils.parseJSON(localStorage.getItem('user'));
            return user && user.type === UserType.ADVERTISER;
        },
        enumerable: true,
        configurable: true
    });
    UserService.prototype.loadInfluencerInfoByCompanyId = function (companyId) {
        if (!companyId) {
            return Observable.of(null);
        }
        return this.get(apiEndpoints.getInfluencerInfo.replace(':companyId', companyId)).map(function (res) {
            return res && res.data ? Object.assign({}, res.data, {
                profilePicture: res.data.profile_image,
            }) : null;
        });
    };
    UserService.prototype.addInfluencerInfo = function (influencerData) {
        this._currentInfluencer = influencerData;
    };
    UserService.prototype.getInfluencerInfo = function () {
        return this._currentInfluencer;
    };
    Object.defineProperty(UserService.prototype, "isInfluencer", {
        get: function () {
            var user = ObjectUtils.parseJSON(localStorage.getItem('user'));
            return user && user.type === UserType.INFLUENCER;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserService.prototype, "isAnalyst", {
        get: function () {
            var user = ObjectUtils.parseJSON(localStorage.getItem('user'));
            return user && user.type === UserType.ANALYST;
        },
        enumerable: true,
        configurable: true
    });
    UserService.prototype.acceptionTermAndCondition = function (userId, title) {
        return this.post(apiEndpoints.updateUserProfile, {
            userId: userId,
            title: title
        });
    };
    UserService.prototype.updateUser = function (firstName, lastName, email, image) {
        var currentUser = ObjectUtils.parseJSON(localStorage.getItem('user'));
        return this.post(apiEndpoints.updateUserProfile, {
            userId: currentUser.data.id,
            firstName: firstName, lastName: lastName, email: email, image: image
        });
    };
    UserService.prototype.updateAcceptTermAndService = function (isAcceptedTermAndService) {
        this._currentInfluencer.acceptedTermService = isAcceptedTermAndService;
    };
    UserService.prototype.updatePassword = function (oldPassword, newPassword) {
        return this.post(apiEndpoints.changepassword, {
            password: oldPassword,
            newPassword: newPassword
        });
    };
    UserService.prototype.hasStartedTrial = function () {
        return this._hasStartedTrial;
    };
    UserService.prototype.loadAccountListByUser = function (user, callback) {
        var task = this.loadAccountListByUserTask(user);
        task.subscribe({
            next: function () {
                if (callback) {
                    callback();
                }
            }
        });
    };
    UserService.prototype.loadAccountListByUserTask = function (user, defaultActiveAccount) {
        var _this = this;
        var belongingCompany = {
            id: user.companyId,
            name: user.companyName
        };
        var task = user.type === UserType.ADVERTISER
            ? this.getCurrentUserInfo()
                .pipe(tap(function (res) {
                var userData = res && res.data;
                if (userData) {
                    belongingCompany.status = userData.company.customerStatus;
                    belongingCompany.inactive = _this.isAdvertiserInactive(belongingCompany);
                    belongingCompany.startDate = userData.company.startDate;
                    _this.setActiveCompany([], belongingCompany, defaultActiveAccount);
                }
            }))
            : this.getAllAdvertiser(user.type, user.companyId)
                .pipe(tap(function (res) {
                if (res && res.data) {
                    var advertisers = res.data;
                    advertisers.forEach(function (ad) { return ad.inactive = _this.isAdvertiserInactive(ad); });
                    _this.setActiveCompany(advertisers, belongingCompany, defaultActiveAccount);
                }
            }));
        return task;
    };
    UserService.prototype.isAdvertiserInactive = function (advertiser) {
        return advertiser.status === CompanyStatus.BLOCKED
            || advertiser.status === CompanyStatus.CHURNED
            || advertiser.status === CompanyStatus.FUTURE;
    };
    UserService.prototype.loadReviewerList = function (companyId) {
        return this.get(apiEndpoints.getReviewerList.replace(':companyId', companyId.toString()))
            .map(function (res) { return res && res.data ? res.data : []; });
    };
    UserService.prototype.getUserBilling = function (companyId) {
        return this.get(apiEndpoints.userBilling.replace(':companyId', companyId.toString()))
            .map(function (res) { return res && res.data ? res.data : null; });
    };
    UserService.prototype.getUserMonthlyUsage = function (companyId) {
        return this.get(apiEndpoints.userMonthlyUsage.replace(':companyId', companyId.toString()));
    };
    UserService.prototype.updateProfile = function (userProfileData) {
        return this.post(apiEndpoints.updateProfile, userProfileData);
    };
    UserService.prototype.updateCurrentUserAvatar = function (image, user) {
        user.data.image = image;
        localStorage.setItem('user', JSON.stringify(user));
    };
    Object.defineProperty(UserService.prototype, "getStartedTrialValue", {
        get: function () {
            var _this = this;
            if (Array.isArray(this.allAdvertisers) && this.allAdvertisers.length > 0) {
                var currentActiveAccount = this.allAdvertisers.find(function (adv) { return adv.id === _this.getCompanyId(); });
                if (!currentActiveAccount) {
                    return false;
                }
                return currentActiveAccount.isTrialed || !this.isFreeUser();
            }
            return false;
        },
        enumerable: true,
        configurable: true
    });
    UserService.prototype.getSignUpPageData = function (companyId) {
        return this.get(apiEndpoints.getSignUpPageData.replace(':companyId', companyId.toString()))
            .map(function (res) { return res && res.data ? res.data : null; });
    };
    UserService.prototype.loadNotificationSetting = function () {
        var _this = this;
        return this.get(apiEndpoints.notificationSetting).map(function (res) {
            if (!res || !res.data) {
                return null;
            }
            return _this.normalizeNotificationSettings(res);
        });
    };
    UserService.prototype.getUserNotificationSettingByToken = function (userId, token) {
        var _this = this;
        return this.get(apiEndpoints.emailSettings, {
            user_id: userId,
            token: token
        }).map(function (res) {
            if (!res || !res.data) {
                return null;
            }
            return _this.normalizeNotificationSettings(res);
        });
    };
    UserService.prototype.saveUserNotificationSettingByToken = function (userId, token, settingData) {
        var settings = [
            {
                type: CommonConstant.NOTIFICATION_ACTIVITY_SETTING,
                schedule: settingData.activity
            },
            {
                type: CommonConstant.NOTIFICATION_UPDATES_SETTING,
                schedule: settingData.updates
            },
            {
                type: CommonConstant.NOTIFICATION_PENDING_ACTION_SETTING,
                schedule: settingData.pendingAction
            },
            {
                type: CommonConstant.NOTIFICATION_PROMOTION_EMAIL_SETTING,
                schedule: settingData.promotionalEmails
            }
        ];
        return this.post(apiEndpoints.emailSettings + "?user_id=" + userId + "&token=" + token, {
            settings: settings
        }).map(function (res) { return res ? res.data : null; });
    };
    UserService.prototype.normalizeNotificationSettings = function (res) {
        var notificationSetting = new NotificationSetting();
        var activity = res.data.settings.find(function (noti) { return noti.type === CommonConstant.NOTIFICATION_ACTIVITY_SETTING; });
        if (activity) {
            notificationSetting.activity = activity.schedule;
        }
        var updates = res.data.settings.find(function (noti) { return noti.type === CommonConstant.NOTIFICATION_UPDATES_SETTING; });
        if (updates) {
            notificationSetting.updates = updates.schedule;
        }
        var pendingAction = res.data.settings.find(function (noti) { return noti.type === CommonConstant.NOTIFICATION_PENDING_ACTION_SETTING; });
        if (pendingAction) {
            notificationSetting.pendingAction = pendingAction.schedule;
        }
        var promotionalEmail = res.data.settings.find(function (noti) { return noti.type === CommonConstant.NOTIFICATION_PROMOTION_EMAIL_SETTING; });
        if (promotionalEmail) {
            notificationSetting.promotionalEmails = promotionalEmail.schedule;
        }
        return notificationSetting;
    };
    UserService.prototype.saveNotificationSetting = function (notificationSetting) {
        var data = [
            {
                type: CommonConstant.NOTIFICATION_ACTIVITY_SETTING,
                schedule: notificationSetting.activity
            },
            {
                type: CommonConstant.NOTIFICATION_UPDATES_SETTING,
                schedule: notificationSetting.updates
            },
            {
                type: CommonConstant.NOTIFICATION_PENDING_ACTION_SETTING,
                schedule: notificationSetting.pendingAction
            }
        ];
        return this.post(apiEndpoints.notificationSetting, {
            settings: data
        });
    };
    UserService.prototype.getSampleData = function () {
        return this.get(apiEndpoints.sampleSetups).map(function (res) { return res && res.data ? res.data : []; });
    };
    UserService.prototype.createSampleData = function (sampleSetUpId, companyId) {
        return this.post(apiEndpoints.setupSampleData.replace(':companyId', companyId.toString()), {
            sampleSetupId: sampleSetUpId
        }).map(function (res) { return res; });
    };
    UserService.prototype.clearAdvertiserData = function () {
        this.allAdvertisers = [];
        this.cacheService.clear(CommonConstant.LIST_ADVERTISER_BELONG_TO_USER);
    };
    /**
     * get the last view from session storage if persisted. Otherwise call API to get from server with retry on error
     * @param {EventType} eventType
     * @param {number} companyId
     */
    UserService.prototype.getLastViewedTime = function (eventType, companyId) {
        var user = ObjectUtils.parseJSON(localStorage.getItem('user'));
        if (!user) {
            return Observable.throw(new Error('Not found user'));
        }
        var lvcKey = CommonConstant.LAST_VIEWED_CAMPAIGN_TIME_KEY_PREFIX + "_" + user.data.id + "_" + companyId;
        if (!sessionStorage.getItem(lvcKey)) {
            var apiUrl = apiEndpoints.lastViewedTime.replace(':type', eventType.toString()).replace(':company_id', companyId.toString());
            return this.get(apiUrl).pipe(retry(CommonConstant.MAX_RETRY_ON_ERROR_LAST_VIEW_TIME))
                .map(function (res) {
                if (res && res.data && res.data.last_viewed_at !== null) {
                    sessionStorage.setItem(lvcKey, res.data.last_viewed_at);
                    return res.data.last_viewed_at;
                }
                return null;
            });
        }
        else {
            return Observable.of(Number(sessionStorage.getItem(lvcKey)));
        }
    };
    /**
     * Call API to update the last view time on campaign pages. Retry on error
     * @param {EventType} eventType
     * @param {number} companyId
     * @returns {Observable<any>}
     */
    UserService.prototype.updateLastViewTime = function (eventType, companyId) {
        if (!this._canViewCampaignNotification) {
            return;
        }
        var apiUrl = apiEndpoints.lastViewedTime.replace(':type', eventType.toString()).replace(':company_id', companyId.toString());
        this.put(apiUrl, {}).pipe(retry(CommonConstant.MAX_RETRY_ON_ERROR_LAST_VIEW_TIME)).subscribe();
    };
    UserService.prototype.lastViewedCampaignTime = function () {
        return this._lastViewedCampaignTime;
    };
    /**
     * load the new events based on the event type from a specific timestamp.
     * Allow to filter with format key=${campaign_id|influencer_id|url_hash}&filter=${campaign_id|influencer_id|campaign_influencer_id}:${value}
     * @param {EventType} eventType
     * @param {number} companyId
     * @param {number} timestamp
     * @param {EventFilter} filter
     * @returns {Observable<any>}
     */
    UserService.prototype.getNewEventFromLastTime = function (eventType, companyId, timestamp, filter) {
        if (!eventType || !companyId || !timestamp || !filter) {
            return Observable.of(null);
        }
        var apiUrl = apiEndpoints.getNewEventsFromTimestamp.replace(':type', eventType.toString())
            .replace(':company_id', companyId.toString())
            .replace(':timestamp', timestamp.toString());
        var requestParams = this.buildRequestParams(filter);
        return this.get(apiUrl, requestParams).map(function (res) { return res ? res.data : null; }).catch(function (err) {
            if (err.status < 500) {
                return Observable.of(null);
            }
            return Observable.throw(err);
        });
    };
    UserService.prototype.buildRequestParams = function (filter) {
        var requestParams = {};
        switch (filter.type) {
            case EventFilterType.CAMPAIGN_ID:
                return Object.assign({}, requestParams, {
                    key: filter.type
                });
            case EventFilterType.INFLUENCER_ID:
                return Object.assign({}, requestParams, {
                    key: filter.type,
                    filter: "campaign_id:" + filter.value
                });
            case EventFilterType.URL_HASH:
                return Object.assign({}, requestParams, {
                    key: filter.type,
                    filter: "campaign_influencer_id:" + filter.value
                });
            default:
                throw new Error('Unsupport event type: ' + filter.type);
        }
    };
    UserService.prototype.clearCampaignLastViewTime = function () {
        this._lastViewedCampaignTime = null;
        this._canViewCampaignNotification = true;
    };
    UserService.prototype.generateCheckoutNewSubscription = function (companyId) {
        return this.get(apiEndpoints.checkoutSubscription.replace(':companyId', companyId.toString())).map(function (res) { return res.data; });
    };
    UserService.prototype.getPortalSession = function (companyId) {
        return this.get(apiEndpoints.portalSession.replace(':companyId', companyId.toString())).map(function (res) { return res.data; });
    };
    UserService.prototype.contactSupport = function () {
        this._contactSupportSubject.next();
    };
    Object.defineProperty(UserService.prototype, "contactSupportRequested", {
        get: function () {
            return this._contactSupportSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    UserService.prototype.getInfluencerUsage = function (companyId) {
        return this.get(apiEndpoints.influencerUsage.replace(':companyId', companyId.toString())).map(function (res) { return res.data; });
    };
    UserService.prototype.triggerUpdateActivatedInfluencers = function () {
        this._activatedInfluencerUpdate.next(null);
    };
    UserService.prototype.setupActivatedInfluencerUpdateFlow = function () {
        var _this = this;
        this.activeInfluencers$ = combineLatest([
            this.companyId.asObservable().pipe(rxFilter(function (x) { return !!x; }), distinctUntilChanged()),
            this._activatedInfluencerUpdate.asObservable()
        ]).pipe(switchMap(function (_a) {
            var companyId = _a[0];
            return _this.getInfluencerUsage(companyId).pipe(catchError(function () { return of(null); }));
        }), shareReplay());
    };
    return UserService;
}(BackendHttpService));
export { UserService };



// WEBPACK FOOTER //
// ./src/app/services/user.service.ts.pre-build-optimizer.js